import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';
import { Type } from '@angular/core';

export class NumberFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    placeholder: string;
    max: number;
    min: number;
    toolTip: string;
    tooltipPosition: string;
    appearCondition: (x: any) => boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        placeholder?: string,
        max?: number,
        min?: number,
        toolTip?: string,
        tooltipPosition?: string,
        appearCondition?: (x: any) => boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.placeholder = placeholder;
        this.max = max;
        this.min = min;
        this.toolTip = toolTip;
        this.tooltipPosition = tooltipPosition;
        this.appearCondition = appearCondition;
    }
}
